import { sessionStorageKeyAuthorizationToken } from '../../const/commonConst';
import { redirectToLogin } from '../../utils/redirectToLogin';
import { getSessionStorage } from '../../utils/sessionStorageHandler';

export const NotFoundPage = () => {
	// 認証トークンをセッションストレージから取得する
	const authorizationToken = getSessionStorage(sessionStorageKeyAuthorizationToken);

	if (!authorizationToken) {
		redirectToLogin();
	}

	return <></>;
};
